import React from 'react';
import { motion } from 'framer-motion';
import Image from '../../../components/AppImage';

const SmartHomeIntro = () => {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-sm font-bold uppercase tracking-[0.4em] text-[#91756A] mb-6 flex items-center">
              <span className="w-8 h-px bg-[#91756A] mr-4"></span> Evolution
            </h2>
            <h3 className="text-4xl md:text-5xl font-bold text-[#4D4C4A] leading-[1.1] mb-12 italic tracking-tighter">
              Connected <br />
              <span className="text-[#91756A]">Environments</span> for Living.
            </h3>
            <div className="space-y-8 text-slate-500 text-lg leading-relaxed">
              <p>
                Modern homes are evolving into connected environments where technology enhances comfort, security, 
                and convenience. VASTECH provides smart home solutions that integrate lighting, climate control, security, 
                and entertainment systems into one seamless digital ecosystem.
              </p>
              <div className="p-8 border-l-4 border-[#91756A] bg-slate-50 italic">
                <p className="text-xl text-slate-600 leading-relaxed">
                  Our smart home technologies allow homeowners to manage and monitor their living spaces easily through 
                  mobile devices or centralized control systems, creating an intelligent and responsive home environment.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="relative aspect-[4/5] overflow-hidden">
              <Image 
                src="/assets/images/Smart-home-page/Smart-Home-1080-5.jpg" 
                alt="Smart Home Technology" 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SmartHomeIntro;